import { render, staticRenderFns } from "./ShareAccordion.vue?vue&type=template&id=db76ca00"
import script from "./ShareAccordion.vue?vue&type=script&lang=js"
export * from "./ShareAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports